import React, { useState, useEffect } from "react";
import Prism from "prismjs";
import "whatwg-fetch";
//import PropTypes from "prop-types";
import { Button, Badge } from "reactstrap";
import firebase from "../firebase";
import useFirestoreCollQuery from "../hooks/use-fs-coll-query";
// import RenderMdx from "../content/renderMdx";
import RenderMd from "../content/renderMd";
import { Bar } from "./loader";
import "./course-list.css";
import "./content.css";

let courseLength = 0;

const Content = props => {
  const db = firebase.firestore();
  const storage = firebase.storage();
  const [content, setContent] = useState();
  const [contentLength, setContentLength] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const [mdcontent, setMDContent] = useState({});

  useEffect(() => {
    Prism.highlightAll();
    let unsubscribe = "";
    setLoading(true);

    const fetchContent = () => {
      const contentRef = db
        .collection("content")
        .where("courseID", "==", `${props.courseID}`)
        .orderBy("lesson");
      unsubscribe = contentRef.onSnapshot((data, i) => {
        setContent(data);
        data.docs.map((doc, i) => {
          //console.log(`${doc.id} => (${JSON.stringify(doc.data(), null, 2)}`);

          if (doc.data().filename) {
            const storageRef = storage.refFromURL(doc.data().filename);
            storageRef.getDownloadURL().then(url => {
              //console.log("content.js -> md url: ", url);

              fetch(url)
                .then(res => res.blob())
                .then(blob => {
                  //console.log("blob: ", blob);

                  const reader = new FileReader();
                  reader.readAsText(blob);
                  reader.onload = () => {
                    setMDContent(prevState => {
                      return { ...prevState, ...{ [doc.id]: reader.result } };
                    });
                  };
                });
            });
          }
        });
        courseLength = data.docs.length || 0;
        //console.log("course array length: ", courseLength);

        setContentLength(courseLength);
      });
    };

    fetchContent();
    // unsubscribe to the listener when unmounting
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (mdcontent) {
      //console.log("mdcontent length: ", Object.keys(mdcontent).length);
      if (
        Object.keys(mdcontent).length > 0 &&
        Object.keys(mdcontent).length === contentLength
      ) {
        setLoading(false);
      }
    }
    //setLoading(false);
  }, [mdcontent]);

  // useEffect(() => {
  //   if (content) {
  //     console.log("content length: ", content.docs.length);
  //   }
  // }, [content]);

  const onClickPrev = index => {
    let curr = activeIndex;
    curr = activeIndex === 0 ? 0 : curr - 1;
    setActiveIndex(curr);
  };

  const onClickNext = index => {
    let curr = activeIndex;
    //curr = activeIndex < courseLength - 1 ? curr + 1 : courseLength - 1;
    if (activeIndex < courseLength - 1) {
      curr += 1;
    }
    setActiveIndex(curr);
  };

  const contentView =
    content &&
    content.docs.slice(activeIndex, activeIndex + 1).map((doc, index) => (
      <li
        key={doc.id}
        // tag="a"
        href="#"
        style={{
          lineHeight: "1",
          paddingTop: "1px",
          paddingBottom: "1px",
          listStyle: "none",
          margin: 0,
          borderBottom: "1px solid #dfe2e5",
          fontSize: "0.9rem"
        }}
      >
        <span className="button-container">
          <Button
            color="link"
            disabled={activeIndex === 0}
            style={{ color: "#C2185B" }}
            onClick={() => onClickPrev(index)}
          >
            Prev
          </Button>
          <p className="course-index">
            {activeIndex + 1} of {contentLength}
          </p>
          <Button
            color="link"
            disabled={activeIndex === Number(contentLength - 1)}
            style={{ color: "#C2185B" }}
            onClick={() => onClickNext(index)}
          >
            Next
          </Button>
        </span>

        <h5>
          {doc.data().title}{" "}
          <Badge pill style={{ fontSize: "11px", fontWeight: "normal" }}>
            {doc.data().lesson}
          </Badge>
        </h5>

        {/* <RenderMdx doc={doc.data().fname} /> */}

        {Object.keys(mdcontent).length === content.docs.length ? (
          <RenderMd mdContent={mdcontent[doc.id]} />
        ) : (
          ""
        )}
      </li>
    ));

  return (
    <>
      <Bar loading={loading} />
      <ul
        style={{
          listStyle: "none",
          margin: 0,
          paddingLeft: "7px",
          paddingRight: "7px",
          borderBottom: "1px solid #dfe2e5"
        }}
      >
        {contentView}
      </ul>
    </>
  );
};

export default Content;
